import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import AnyInput from './index';
const AnyInputMeta = {
  id: 'anyInput',
  component: AnyInput,
  isFormEditor: true,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'any',
      title: '当前值'
    }, {
      id: 'placeholder',
      type: 'string'
    }, {
      id: 'hideIcon',
      type: 'boolean',
      title: '隐藏类型图标'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '数据发生修改时触发，$event 为新的值'
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    const {
      type
    } = dataSchema;
    // 基础类型不做推荐
    if (type === 'string' || type === 'number' || type === 'boolean' || type === 'integer') return;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER + 1000,
      layout: {
        type: 'anyInput',
        bindings: {
          'v-model': dataPath
        }
      }
    };
  }
};
export default AnyInputMeta;
//# sourceMappingURL=meta.js.map
